__turbopack_context__.v({
  "container": "categories-module-scss-module__-h1Zmq__container",
  "footer": "categories-module-scss-module__-h1Zmq__footer",
  "header": "categories-module-scss-module__-h1Zmq__header",
  "title": "categories-module-scss-module__-h1Zmq__title",
  "wrapperLines": "categories-module-scss-module__-h1Zmq__wrapperLines",
});
